import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, ICompanyUserClient } from 'interfaceAdapter/gatewaySchemas/ICompanyUserClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanyUserClient implements ICompanyUserClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, userId } = input;
        const PATH = `${API_LOCATION_URL}/company/user?user_id=${userId}`;
        const method = 'GET';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
